import React from 'react';
import Translate from '../Translate/Translate';
import ProductReturnImg from '../../images/product__return.svg';
import ProductBoxImg from '../../images/product__shipping.svg';

export default class ProductExtra extends React.Component {
  public render() {
    return (
      <div className="mx-0 my-5">
        <div className="flex items-center mx-0 my-2.5">
          <img className="w-6 h-6 mr-2.5" src={ProductBoxImg} alt="" />
          <p className="leading-6">
            <Translate component="header" keyword="delivery-info" />
          </p>
        </div>
        <div className="flex items-center mx-0 my-2.5">
          <img className="w-6 h-6 mr-2.5" src={ProductReturnImg} alt="" />
          <p className="leading-6">
            <Translate component="header" keyword="return-exchange" />
          </p>
        </div>
      </div>
    );
  }
}
